import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Media,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { connect } from "react-redux";

import moment from "moment-timezone";

import { toggleRightSidebar } from "../../../store/actions";
import { getMainData, ClearData } from "../../../store/Notification/actions";

class NotificationDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      nepo: true,
    };
    this.toggle = this.toggle.bind(this);
    this.toggleRightbar = this.toggleRightbar.bind(this);
  }

  componentDidMount() {
    this.props.getMainData();
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
      nepo: false,
    }));
    this.props.ClearData();
  }
  toggleRightbar() {
    this.props.toggleRightSidebar();
  }
  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          tag="li"
          className="d-inline-block"
        >
          <DropdownToggle
            tag="button"
            className="btn header-item noti-icon waves-effect"
            id="page-header-notifications-dropdown"
          >
            <i className="ri-notification-3-line"></i>
            {this.props.notifications.length > 0 && this.state.nepo && (
              <span className="noti-dot"></span>
            )}
          </DropdownToggle>
          <DropdownMenu right className="dropdown-menu dropdown-menu-lg p-0">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0">Notifications</h6>
                </Col>

                {this.props.notifications.length > 0 && (
                  <div className="col-auto">
                    <Link
                      to="#"
                      onClick={this.toggleRightbar}
                      className="small"
                    >
                      View All
                    </Link>
                  </div>
                )}
              </Row>
            </div>
            <SimpleBar style={{ maxHeight: "230px" }}>
              {this.props.notifications.length > 0 ? (
                this.props.notifications?.map((n) => (
                  <div key={n.id} className="text-reset notification-item">
                    <Media>
                      <div className="avatar-xs mr-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="ri-notification-3-line"></i>
                        </span>
                      </div>
                      <Media body>
                        <h6 className="mt-0 mb-1">{n.subject}</h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">{n.body}</p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline"></i>{" "}
                            {
                              // moment(n.createdon, 'DD-MM-YYYY HH:mm:ss')
                              // .tz("Atlantic/Reykjavik")
                              // .fromNow()

                              moment
                                .tz(n.createdon, "Atlantic/Reykjavik")
                                .tz("Asia/Kolkata")
                                .fromNow()
                              // .format( 'lll')
                              // .format( 'DD/MM/YYYY hh:mm a')
                            }
                          </p>
                        </div>
                      </Media>
                    </Media>
                  </div>
                ))
              ) : (
                <h6 className="text-center mb-10">No Notifications</h6>
              )}
            </SimpleBar>
            {this.props.notifications.length > 0 && (
              <div className="p-2 border-top">
                <Link
                  to="#"
                  onClick={this.toggleRightbar}
                  className="btn btn-sm btn-link font-size-14 btn-block text-center"
                >
                  <i className="mdi mdi-arrow-right-circle mr-1"></i>
                  View More
                </Link>
              </div>
            )}
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  const { notifications } = state.Notification;
  return { layoutType, notifications };
};
export default connect(mapStatetoProps, {
  toggleRightSidebar,
  getMainData,
  ClearData,
})(NotificationDropdown);
